/**
 * File generated by js-routes 2.2.8
 * Based on Rails 7.0.8.7 routes of Media::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adform_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdformAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adform_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdformAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adform_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdformAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adform_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdformAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdwordsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adwords(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAdwordsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAmazonAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAmazonAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/amazon_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAmazonAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/amazon_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupAmazonAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/display_ads_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupDisplayAdsAccessIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/display_ads_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupDisplayAdsAccessIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupDV360AdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupDV360AdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdPageUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdPagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookBrandPageUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookBrandPagePath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookBrandPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookBrandPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookPostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupFacebookPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/instagram_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupInstagramPostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/instagram_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupInstagramPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMetaAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMetaAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMetaAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMetaAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/my_target_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMyTargetAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"my_target_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/my_target_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupMyTargetAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"my_target_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/pinterest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupPinterestIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/pinterest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupPinterestIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupSnapchatAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupSnapchatAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTiktokAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTiktokAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTiktokAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTiktokAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/twitter_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTwitterAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/twitter_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTwitterAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/twitter_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTwitterPostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/twitter_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupTwitterPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/youtube_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupYoutubePostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"youtube_posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/youtube_posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountSetupYoutubePostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"youtube_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /third_party/integrations/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateThirdPartyIntegrationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/integrations/:id/activate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateThirdPartyIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateUserUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /activate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"activate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /activate_sso/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateUserSsoUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activate_sso"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /activate_sso/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activateUserSsoPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"activate_sso"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard/activated_media_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activatedMediaRecordsCreativeLifecycleDashboardIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"activated_media_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard/activated_media_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const activatedMediaRecordsCreativeLifecycleDashboardIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"activated_media_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads/add_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addAssetsCreativeLifecycleCoreAssetUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[2,[7,"/"],[2,[6,"add_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads/add_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const addAssetsCreativeLifecycleCoreAssetUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[2,[7,"/"],[2,[6,"add_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /admin(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/account_tracked_terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAccountTrackedTermUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_tracked_terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/account_tracked_terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAccountTrackedTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_tracked_terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/account_tracked_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAccountTrackedTermsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_tracked_terms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/account_tracked_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAccountTrackedTermsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"account_tracked_terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis/words/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisWordUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/analysis/words/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisWordPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis/words(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisWordsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/analysis/words(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAnalysisWordsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/asset_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAssetAttributeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"asset_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/asset_attributes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAssetAttributePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"asset_attributes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/asset_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAssetAttributesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"asset_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/asset_attributes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAssetAttributesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"asset_attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_challenges"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditOrganizationUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditOrganizationPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_posts/escalate_challenge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsEscalateChallengeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[6,"escalate_challenge"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_posts/escalate_challenge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsEscalateChallengePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[6,"escalate_challenge"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_posts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsSearchUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_posts/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditPostsSearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditReprocessUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditReprocessPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditReprocessesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminAuditReprocessesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryClassificationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryClassificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryClassificationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategoryClassificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategorySubscriptionsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCategorySubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChannelUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChannelsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminChannelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClassifierSubscriptionUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClassifierSubscriptionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClassifierSubscriptionsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminClassifierSubscriptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompaniesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompaniesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/ad_accounts(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyAdAccountsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/ad_accounts(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyAdAccountsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyApiAuthorizationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyApiAuthorizationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyApiAuthorizationsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyApiAuthorizationsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyBrandUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyBrandPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyBrandsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyBrandsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCategorySubscriptionUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCategorySubscriptionPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCategorySubscriptionsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCategorySubscriptionsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyChannelConfigUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyChannelConfigPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyChannelConfigsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyChannelConfigsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/clients(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyClientsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/clients(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyClientsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"clients"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyContractUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyContractPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyContractsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyContractsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/core_assets/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCoreAssetUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/core_assets/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCoreAssetPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/core_assets(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"core_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/core_assets(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyCoreAssetsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"core_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/guidelines(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyGuidelinesUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/guidelines(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyGuidelinesPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/matching_configs/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyMatchingConfigUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"matching_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/matching_configs/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyMatchingConfigPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"matching_configs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/matching_configs(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyMatchingConfigsUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"matching_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/matching_configs(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyMatchingConfigsPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"matching_configs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyOrganizationFeatureUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyOrganizationFeaturePath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyOrganizationFeaturesUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyOrganizationFeaturesPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/product_features/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyProductFeatureUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"product_features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/product_features/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyProductFeaturePath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"product_features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/product_features(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyProductFeaturesUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"product_features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/product_features(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyProductFeaturesPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"product_features"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/scores(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyScoresUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/scores(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanyScoresPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/security/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySecurityUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/security/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySecurityPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySsoConfigurationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/:id(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySsoConfigurationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySsoConfigurationIndexUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminCompanySsoConfigurationIndexPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dv3b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDv3bIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dv3b"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dv3b(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminDv3bIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dv3b"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailSettingUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/email_settings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailSettingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailSettingsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/email_settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailSettingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/erd(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminErdUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"erd"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/erd(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminErdPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"erd"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureTrainingAssetsUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeatureTrainingAssetsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeaturesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminFeaturesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_check_validations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineCheckValidationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_check_validations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineCheckValidationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_check_validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineCheckValidationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_check_validations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineCheckValidationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_details/visual_tag_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineDetailsVisualTagOptionsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[6,"visual_tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_details/visual_tag_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineDetailsVisualTagOptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[6,"visual_tag_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:guideline_id/guideline_details(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineGuidelineDetailsUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"guideline_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:guideline_id/guideline_details(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminGuidelineGuidelineDetailsPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"guideline_details"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminImageUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/images/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminImagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"images"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminImagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/images(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminImagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIndustriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/industries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIndustriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIndustryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/industries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminIndustryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoAssetJobUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoAssetJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoAssetJobsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoAssetJobsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoElementUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoElementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoElementsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminLogoElementsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_ad_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAdUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_ad_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_ad_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAdUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_ad_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_asset_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAssetDownloadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_asset_downloads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_asset_downloads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAssetDownloadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_asset_downloads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_asset_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAssetUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_asset_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_asset_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualAssetUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_asset_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/manual_cta_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualCtaUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_cta_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/manual_cta_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminManualCtaUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"manual_cta_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationsDemoAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminOrganizationsDemoAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPartnerUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPartnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPartnersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPartnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pending_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPendingAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pending_assets"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pending_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPendingAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pending_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/preflight_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPreflightOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/preflight_organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPreflightOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/pretests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPretestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pretests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPretestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/preflight_organizations/:org_id/pretests(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPretestsUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"pretests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/preflight_organizations/:org_id/pretests(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminPretestsPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"pretests"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRepresentationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRepresentationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRepresentationIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminRepresentationIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/inflight/guidelines/:guideline_id/checks(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightGuidelineChecksUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/inflight/guidelines/:guideline_id/checks(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightGuidelineChecksPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/inflight/organizations/:organization_id/guidelines(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightOrganizationGuidelinesUrl = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/inflight/organizations/:organization_id/guidelines(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightOrganizationGuidelinesPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/inflight/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/inflight/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewInflightOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/preflight/guidelines/:guideline_id/checks(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightGuidelineChecksUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/preflight/guidelines/:guideline_id/checks(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightGuidelineChecksPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/preflight/organizations/:organization_id/guidelines(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightOrganizationGuidelinesUrl = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/preflight/organizations/:organization_id/guidelines(.:format)
 * @param {any} organizationId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightOrganizationGuidelinesPath = /*#__PURE__*/ __jsr.r({"organization_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[3,"organization_id"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/preflight/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/preflight/organizations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminReviewPreflightOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"organizations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/searchable_tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSearchableTagUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/searchable_tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSearchableTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/searchable_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSearchableTagsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_tags"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/searchable_tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminSearchableTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"searchable_tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/autotag(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagAutotagUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"autotag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/autotag(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagAutotagPath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"autotag"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/images(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagImagesUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/images(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagImagesPath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/queue(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagQueueUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/queue(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagQueuePath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"queue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/rule(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagRuleUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/rule(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagRulePath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"rule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/turk_hit_types/:id(.:format)
 * @param {any} tagId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagTurkHitTypeUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"turk_hit_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/turk_hit_types/:id(.:format)
 * @param {any} tagId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagTurkHitTypePath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"turk_hit_types"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/turk_hit_types(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagTurkHitTypesUrl = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"turk_hit_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/:tag_id/turk_hit_types(.:format)
 * @param {any} tagId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagTurkHitTypesPath = /*#__PURE__*/ __jsr.r({"tag_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[3,"tag_id"],[2,[7,"/"],[2,[6,"turk_hit_types"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/tracked_terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrackedTermUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tracked_terms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrackedTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tracked_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrackedTermsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tracked_terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrackedTermsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/training_asset_annotations/:id(.:format)
 * @param {any} id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrainingAssetAnnotationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"training_asset_annotations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/training_asset_annotations/:id(.:format)
 * @param {any} id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrainingAssetAnnotationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"training_asset_annotations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/training_asset_annotations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrainingAssetAnnotationsUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"training_asset_annotations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/training_asset_annotations(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrainingAssetAnnotationsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"training_asset_annotations"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrialGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrialGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrialGuidelineChecksUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminTrialGuidelineChecksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcFilterUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcFilterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcFiltersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcFiltersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_location_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcLocationFilterUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_location_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_location_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcLocationFilterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_location_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_location_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcLocationFiltersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_location_filters"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_location_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUgcLocationFiltersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_location_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/act_as(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserActAsUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"act_as"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:user_id/act_as(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserActAsPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"act_as"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/become(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserBecomeUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"become"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:user_id/become(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserBecomePath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"become"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/disable(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserDisableUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:user_id/disable(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserDisablePath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/enable(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserEnableUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:user_id/enable(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserEnablePath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:user_id/reset_password(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserResetPasswordUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:user_id/reset_password(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUserResetPasswordPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminsInternalUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/admins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const adminsInternalUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"admins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/pinterest/all_ad_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allAdAccountsAccountSetupPinterestIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[6,"all_ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/pinterest/all_ad_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const allAdAccountsAccountSetupPinterestIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[6,"all_ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /analytics/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /analytics/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/categories/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics/categories/:category_id/posts(.:format)
 * @param {any} categoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoryPostsUrl = /*#__PURE__*/ __jsr.r({"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/categories/:category_id/posts(.:format)
 * @param {any} categoryId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsCategoryPostsPath = /*#__PURE__*/ __jsr.r({"category_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsPostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analyticsPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/ad_formats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdFormatsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ad_formats"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/ad_formats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAdFormatsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"ad_formats"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/boxplot_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiBoxplotAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"boxplot_assets"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/boxplot_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiBoxplotAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"boxplot_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiBrandsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/brands(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiBrandsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"brands"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/category_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/category_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryFormUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_forms/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/category_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryFormsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_forms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCategoryFormsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiChannelsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/channels(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiChannelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"channels"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyBrandCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyBrandCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/content_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiContentTypesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"content_types"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/content_types(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiContentTypesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"content_types"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/facebook_ad_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiFacebookAdCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"facebook_ad_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/facebook_ad_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiFacebookAdCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"facebook_ad_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/guidelines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiGuidelinesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/guidelines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiGuidelinesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/markets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMarketsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"markets"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /api/markets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const apiMarketsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"markets"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetCheckUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /asset/check(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[6,"check"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetCreateUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /asset/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetCreatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetDeleteUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /asset/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetDeletePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /asset_downloads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetDownloadUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset_downloads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /asset_downloads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const assetDownloadPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"asset_downloads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/breakdowns/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceBreakdownsBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"breakdowns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/campaigns/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCampaignsBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/categories/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoriesBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/creatives/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryCreativesBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/creatives/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryCreativesBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/creatives/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryCreativesBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/creatives/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryCreativesBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/overview/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryOverviewBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/overview/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryOverviewBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/overview/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryOverviewBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/category/:category_id/overview/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} categoryId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCategoryOverviewBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"category_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"category_id"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/classification/:classification_id/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} classificationId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceClassificationBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"classification_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"classification"],[2,[7,"/"],[2,[3,"classification_id"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/classification/:classification_id/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} classificationId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceClassificationBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"classification_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"classification"],[2,[7,"/"],[2,[3,"classification_id"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/classification/:classification_id/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} classificationId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceClassificationBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"classification_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"classification"],[2,[7,"/"],[2,[3,"classification_id"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/classification/:classification_id/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} classificationId
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceClassificationBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"classification_id":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"classification"],[2,[7,"/"],[2,[3,"classification_id"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/creatives/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceCreativesBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewBreakdownUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type/:breakdown(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewBreakdownPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewBreakdown2Url = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audience/overview/:breakdown_type/:breakdown/:breakdown2(.:format)
 * @param {any} channel
 * @param {any} breakdownType
 * @param {any} breakdown
 * @param {any} breakdown2
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audienceOverviewBreakdown2Path = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"breakdown_type":{"r":true},"breakdown":{"r":true},"breakdown2":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[3,"breakdown_type"],[2,[7,"/"],[2,[3,"breakdown"],[2,[7,"/"],[2,[3,"breakdown2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /audit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /audit/ad_words_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditAdWordsAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"ad_words_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/ad_words_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditAdWordsAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"ad_words_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditCreativeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditCreativePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditCreativesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/creatives(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditCreativesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"creatives"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/diagnostics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditDiagnosticsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"diagnostics"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/diagnostics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditDiagnosticsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"diagnostics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/filter_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditFilterDataUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"filter_data"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/filter_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditFilterDataPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"filter_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/trends(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditHistoricalTrendsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"trends"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/trends(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditHistoricalTrendsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"trends"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/placement_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditPlacementDataUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"placement_data"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/placement_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditPlacementDataPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"placement_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditQueriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/rankings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditRankingsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/rankings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditRankingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/scorecards/:asset_id(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditScorecardUrl = /*#__PURE__*/ __jsr.r({"asset_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"asset_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scorecards/:asset_id(.:format)
 * @param {any} assetId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditScorecardPath = /*#__PURE__*/ __jsr.r({"asset_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scorecards"],[2,[7,"/"],[2,[3,"asset_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/segmentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditSegmentationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"segmentation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/segmentation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditSegmentationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"segmentation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const auditUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authLoggingApiUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authLoggingApiPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /auth/oauth_failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authOauthFailureUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"oauth_failure"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /auth/oauth_failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authOauthFailurePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"oauth_failure"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticatedRootUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authenticatedRootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /account_setup/adform_ads/authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizationAccountSetupAdformAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adform_ads/authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizationAccountSetupAdformAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/pinterest/authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizationAccountSetupPinterestIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/pinterest/authorization(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizationAccountSetupPinterestIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[6,"authorization"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizeAccountSetupAmazonAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const authorizeAccountSetupAmazonAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/back_to_internal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backToInternalInternalUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"back_to_internal"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/back_to_internal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const backToInternalInternalUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"back_to_internal"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/category/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarksCategoryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/category/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarksCategoryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/industry/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarksIndustryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/industry/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const benchmarksIndustryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/:media_type/best_and_worst_performers(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bestAndWorstPerformersUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"best_and_worst_performers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/:media_type/best_and_worst_performers(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bestAndWorstPerformersPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"best_and_worst_performers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/bme_remapping_summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bmeRemappingSummarySettingsLinkedPlatformAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bme_remapping_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/bme_remapping_summary(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bmeRemappingSummarySettingsLinkedPlatformAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"bme_remapping_summary"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /brandconsistency/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /brandconsistency/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/brandcues/:id(.:format)
 * @param {any} brandId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandBrandcueUrl = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"brandcues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/brandcues/:id(.:format)
 * @param {any} brandId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandBrandcuePath = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"brandcues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/brandcues(.:format)
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandBrandcuesUrl = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"brandcues"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/brandcues(.:format)
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandBrandcuesPath = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"brandcues"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /brand_cues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandCueUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /brand_cues/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandCuePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /brand_cues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandCuesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /brand_cues(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandCuesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/usage(.:format)
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandUsageUrl = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /brandconsistency/:brand_id/usage(.:format)
 * @param {any} brandId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandUsagePath = /*#__PURE__*/ __jsr.r({"brand_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[2,[7,"/"],[2,[3,"brand_id"],[2,[7,"/"],[2,[6,"usage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /brandconsistency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /brandconsistency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const brandsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brandconsistency"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateApiCompanyBrandCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateApiCompanyBrandCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateApiCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateApiCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateTaxonomyCompanyBrandCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateTaxonomyCompanyBrandCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateTaxonomyCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/bulk_create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkCreateTaxonomyCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"bulk_create"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/bulk_deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDeactivateCreativeLifecycleCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"bulk_deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/bulk_deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkDeactivateCreativeLifecycleCoreAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"bulk_deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/bulk_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkEditInternalUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/bulk_edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkEditInternalUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateInternalUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/bulk_update(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdateInternalUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"bulk_update"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/bulk_update_partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdatePartnerCreativeLifecycleCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"bulk_update_partner"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/bulk_update_partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bulkUpdatePartnerCreativeLifecycleCoreAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"bulk_update_partner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /stats/cache(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cacheStatsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"cache"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stats/cache(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cacheStatsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"cache"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns/:id/campaign_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignAssetsTaxonomyCustomUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns/:id/campaign_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignAssetsTaxonomyCustomUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/campaign_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignAssetsTaxonomyUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/campaign_assets(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignAssetsTaxonomyUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_campaigns/:id/campaign_records(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignRecordsCreativeCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_campaigns/:id/campaign_records(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignRecordsCreativeCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"campaign_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignsAccountSetupDV360AdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const campaignsAccountSetupDV360AdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancelUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/categories_graph(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoriesGraphUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/categories_graph(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoriesGraphPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoriesSearchIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /search/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoriesSearchIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/category_activity(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryActivityUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"category_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/category_activity(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryActivityPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"category_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/:media_type/category_anlaysis(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryAnalysisUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"category_anlaysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/:media_type/category_anlaysis(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryAnalysisPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"category_anlaysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/categories/:id/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryComparisonReportUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/categories/:id/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const categoryComparisonReportPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes/change_impact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeImpactApiCompanyBrandCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"change_impact"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes/change_impact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeImpactApiCompanyBrandCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"change_impact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/change_impact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeImpactApiCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"change_impact"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/change_impact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeImpactApiCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"change_impact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id/change_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeStateTaxonomyCustomTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id/change_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const changeStateTaxonomyCustomTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/check_inactive_page_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkInactivePageAccessAccountSetupFacebookBrandPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"check_inactive_page_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/check_inactive_page_access(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkInactivePageAccessAccountSetupFacebookBrandPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"check_inactive_page_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/:id/switch_to(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clientSwitchToUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /clients/:id/switch_to(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const clientSwitchToPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"switch_to"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup/company_breakdown(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyBreakdownSettingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"company_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup/company_breakdown(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyBreakdownSettingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"company_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup/company_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyChartSettingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"company_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup/company_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyChartSettingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"company_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/category/overview/company_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDataBenchmarksCategoryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"company_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/category/overview/company_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDataBenchmarksCategoryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"company_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/industry/overview/company_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDataBenchmarksIndustryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"company_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/industry/overview/company_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const companyDataBenchmarksIndustryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"company_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/:view_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparisonCustomUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[3,"view_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/:view_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparisonCustomPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[3,"view_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparisonReportUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comparisonReportPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/display_ads_access/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAccountSetupDisplayAdsAccessIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/display_ads_access/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmAccountSetupDisplayAdsAccessIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/confirm_new_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmNewAccountsAccountSetupDV360AdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"confirm_new_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/confirm_new_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmNewAccountsAccountSetupDV360AdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"confirm_new_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmSettingsUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmSettingsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id/confirm_sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmSsoSettingsUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id/confirm_sso(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirmSsoSettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_sso"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/connected_data_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectedDataAssetsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"connected_data_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/connected_data_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectedDataAssetsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"connected_data_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/data_coverage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectionsAdAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"data_coverage"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/data_coverage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connectionsAdAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"data_coverage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contentApiUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contentApiPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /contract/data_point_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contractDataPointUsageUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"data_point_usage"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /contract/data_point_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contractDataPointUsagePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"data_point_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /contract/media_spend_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contractMediaSpendUsageUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"media_spend_usage"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /contract/media_spend_usage(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const contractMediaSpendUsagePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"media_spend_usage"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/core_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coreAssetsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"core_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/core_assets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coreAssetsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"core_assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countsInternalGuidelinesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/counts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const countsInternalGuidelinesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"counts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/code_usage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coverbandWebUrl = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"code_usage"]]]], true);

/**
 * Generates rails route to
 * /admin/code_usage
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const coverbandWebPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"code_usage"]]]]);

/**
 * Generates rails route to
 * /api/category_assets/create_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategoryApiCategoryAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_assets/create_category(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCategoryApiCategoryAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[2,[7,"/"],[2,[6,"create_category"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createComparisonCustomUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createComparisonCustomPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /contract/data_point_usage/create_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCsvContractDataPointUsageUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"data_point_usage"],[2,[7,"/"],[2,[6,"create_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /contract/data_point_usage/create_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createCsvContractDataPointUsagePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"contract"],[2,[7,"/"],[2,[6,"data_point_usage"],[2,[7,"/"],[2,[6,"create_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements/:id/create_jobs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createJobsAdminLogoElementUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements/:id/create_jobs(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createJobsAdminLogoElementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"create_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners/create_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createLinkSettingsPartnersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"create_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners/create_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const createLinkSettingsPartnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"create_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /creative_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creative_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /creative_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /clients/:id/creative(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeClientUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"creative"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /clients/:id/creative(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeClientPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"creative"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCoreAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCoreAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCoreAssetUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleCoreAssetUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleDashboardIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const creativeLifecycleDashboardIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /csp-violation-report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cspViolationReportUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"csp-violation-report"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /csp-violation-report(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cspViolationReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"csp-violation-report"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/preflight_organizations/:org_id/pretests/csv(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvAdminPretestsUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/preflight_organizations/:org_id/pretests/csv(.:format)
 * @param {any} orgId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const csvAdminPretestsPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"preflight_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_report_form_field_values(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customReportFormFieldValuesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_report_form_field_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_report_form_field_values(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customReportFormFieldValuesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_report_form_field_values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_campaigns/dashboard_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardRecordsCreativeCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[6,"dashboard_records"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /creative_campaigns/dashboard_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboardRecordsCreativeCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_campaigns"],[2,[7,"/"],[2,[6,"dashboard_records"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataAdminAuditReprocessesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataAdminAuditReprocessesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/category/overview/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataBenchmarksCategoryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/category/overview/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataBenchmarksCategoryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /benchmarks/industry/overview/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataBenchmarksIndustryReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /benchmarks/industry/overview/data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataBenchmarksIndustryReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"benchmarks"],[2,[7,"/"],[2,[6,"industry"],[2,[7,"/"],[2,[6,"overview"],[2,[7,"/"],[2,[6,"data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataLinkApiUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dataLinkApiPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /audit/rules/other(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deprecatedIndexGuidelinesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"other"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/rules/other(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deprecatedIndexGuidelinesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rules"],[2,[7,"/"],[2,[6,"other"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSsoSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroyUserSsoSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableInternalUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disableInternalUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pdf_scorecards/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadPreflightPdfScorecardUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pdf_scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pdf_scorecards/:id/download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const downloadPreflightPdfScorecardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pdf_scorecards"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateAdminGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateAdminGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_details/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateAdminGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_details/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateAdminGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateInternalGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateInternalGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guideline_details/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateInternalGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guideline_details/:id/duplicate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateInternalGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/:uuid/duplicate(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateReportingReportUrl = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/:uuid/duplicate(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const duplicateReportingReportPath = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"duplicate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountSetupFacebookAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountSetupFacebookAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountSetupFacebookAdPageUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ad_pages/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAccountSetupFacebookAdPagePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis/words/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAnalysisWordUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/analysis/words/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAnalysisWordPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id/edit(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAuditPostUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id/edit(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminAuditPostPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCategoryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/categories/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCategoryClassificationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCategoryClassificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channels/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminChannelUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channels/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminClassifierSubscriptionUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/classifier_subscriptions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminClassifierSubscriptionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"classifier_subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyApiAuthorizationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyApiAuthorizationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyBrandUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyBrandPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyChannelConfigUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyChannelConfigPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyContractUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyContractPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyOrganizationFeatureUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanyOrganizationFeaturePath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/security/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanySecurityUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/security/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanySecurityPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"security"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanySsoConfigurationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/:id/edit(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminCompanySsoConfigurationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEmailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEmailSettingUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/email_settings/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminEmailSettingPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminFeatureUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminFeaturePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminFeatureTrainingAssetsUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminFeatureTrainingAssetsPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_check_validations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelineCheckValidationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_check_validations/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelineCheckValidationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_check_validations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guideline_details/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guideline_details/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/industries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminIndustryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/industries/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminIndustryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"industries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminJobUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLogoAssetJobUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_asset_jobs/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLogoAssetJobPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_asset_jobs"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLogoElementUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminLogoElementPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPartnerUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminPartnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminRepresentationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminRepresentationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/edit(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminReviewGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/edit(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminReviewGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tracked_terms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTrackedTermUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tracked_terms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTrackedTermPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTrialGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/trial_guideline_checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminTrialGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"trial_guideline_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_filters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUgcFilterUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_filters/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUgcFilterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editAdminUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/category_forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCategoryFormUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_forms/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCategoryFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editApiCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /brand_cues/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBrandCueUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /brand_cues/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBrandCuePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit_brand_words(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBrandWordsAdminCompanyBrandUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_brand_words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/edit_brand_words(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editBrandWordsAdminCompanyBrandPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_brand_words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/edit/:report_id(.:format)
 * @param {any} channel
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editComparisonCustomUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/edit/:report_id(.:format)
 * @param {any} channel
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editComparisonCustomPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCreativeLifecycleCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/campaigns/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editCreativeLifecycleCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/edit_data_dates(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDataDatesAdminCompanyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_data_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/edit_data_dates(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editDataDatesAdminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_data_dates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:id/edit_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editImageAdminGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:id/edit_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editImageAdminGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewChallengeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewChallengePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewGuideUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewGuidePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewProcessControlCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editInternalReviewProcessControlCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPreflightPretestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editPreflightPretestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editRailsConductorInboundEmailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/:uuid/edit(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editReportingReportUrl = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/:uuid/edit(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editReportingReportPath = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scoring/consistency/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editScoringConsistencyUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scoring"],[2,[7,"/"],[2,[6,"consistency"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scoring/consistency/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editScoringConsistencyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scoring"],[2,[7,"/"],[2,[6,"consistency"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSearchUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /search/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSearchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/logo/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsCompanyLogoUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/logo/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsCompanyLogoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsLinkedPlatformAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsLinkedPlatformAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsPartnerUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsPartnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/permissions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsUserPermissionUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/permissions/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editSettingsUserPermissionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCompanyTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCustomTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editTaxonomyCustomTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/:id/edit(.:format)
 * @param {any} integrationConfigId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editThirdPartyIntegrationConfigEligibilityRuleUrl = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/:id/edit(.:format)
 * @param {any} integrationConfigId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editThirdPartyIntegrationConfigEligibilityRulePath = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const editUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/channels/eligibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eligibilityApiChannelsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"eligibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/channels/eligibility(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const eligibilityApiChannelsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"eligibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableInternalUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enableInternalUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/escalate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const escalateInternalReviewChallengeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"escalate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/escalate(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const escalateInternalReviewChallengePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"escalate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsAdminRepresentationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsAdminRepresentationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsInternalReviewChallengeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsInternalReviewChallengePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsInternalReviewProcessControlCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id/evaluation_props(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const evaluationPropsInternalReviewProcessControlCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"evaluation_props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /clients/facebook_account_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookAccountResetClientsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"facebook_account_reset"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /clients/facebook_account_reset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookAccountResetClientsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"facebook_account_reset"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /facebook/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookCategoryImagesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /facebook/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookCategoryImagesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /facebook/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookCategoryImagesOutsideDateRangeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /facebook/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookCategoryImagesOutsideDateRangePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /facebook/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /facebook/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"facebook"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/facebook_page_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookPageValidationAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"facebook_page_validation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/facebook_page_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookPageValidationAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"facebook_page_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/facebook_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookValidationAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"facebook_validation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/facebook_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const facebookValidationAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"facebook_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /filter_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filterQueriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"filter_queries"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /filter_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const filterQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"filter_queries"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formOptionsAdminCategoryClassificationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formOptionsAdminCategoryClassificationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/category_forms/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formOptionsApiCategoryFormsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_forms/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const formOptionsApiCategoryFormsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/guideline_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelineGroupingDimensionsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guideline_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/guideline_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelineGroupingDimensionsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guideline_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/guideline_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelineRecordsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guideline_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/guideline_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelineRecordsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"guideline_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelinesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/rules(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const guidelinesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"rules"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/hashtags/:hashtag_value/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} hashtagValue
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hashtagComparisonReportUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"hashtag_value":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"hashtags"],[2,[7,"/"],[2,[3,"hashtag_value"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/hashtags/:hashtag_value/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} hashtagValue
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hashtagComparisonReportPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"hashtag_value":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"hashtags"],[2,[7,"/"],[2,[3,"hashtag_value"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hashtagsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hashtagsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const heinekenApiUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const heinekenApiPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /help_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /help_center(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /help_center/facebook_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterFacebookPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[2,[7,"/"],[2,[6,"facebook_pages"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /help_center/facebook_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterFacebookPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[2,[7,"/"],[2,[6,"facebook_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help_center/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterResetPasswordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /help_center/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const helpCenterResetPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help_center"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/saml/idp_sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const idpSignOutUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"idp_sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/saml/idp_sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const idpSignOutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"idp_sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"instagram"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"instagram"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/attributes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryAttributesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/attributes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryAttributesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"attributes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/audiences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryAudiencesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/audiences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryAudiencesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryImagesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryImagesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryImagesOutsideDateRangeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramCategoryImagesOutsideDateRangePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /accounts/instagram_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramValidationAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"instagram_validation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/instagram_validation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagramValidationAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"instagram_validation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ad_account_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdAccountMetricsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ad_account_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/ad_account_metrics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalAdAccountMetricsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ad_account_metrics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360AdAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360AdAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360AdAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360AdAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360CampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360CampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360CampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalDV360CampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/error_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalErrorQueriesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/error_queries(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalErrorQueriesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/error_queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalErrorQueryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/error_queries/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalErrorQueryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/ads/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ads"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/ad_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/ad_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/ad_formats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdFormatUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_formats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/ad_formats/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAdFormatPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"ad_formats"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/audits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/audits/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audits"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/audit_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audit_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/audit_assets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audit_assets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/audit_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditPostUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/audit_posts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerAuditPostPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerChannelUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/channels/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerChannelPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerCompanyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/companies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdCreativeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdCreativePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdGroupUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/facebook_ad_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerFacebookAdGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"facebook_ad_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/guideline_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guideline_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/guideline_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guideline_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerHomeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/home(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerHomePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"home"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/markets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerMarketUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"markets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/markets/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerMarketPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"markets"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/organization_brands/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerOrganizationBrandUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"organization_brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/organization_brands/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerOrganizationBrandPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"organization_brands"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/publishers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerPublisherUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"publishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/publishers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerPublisherPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"publishers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/explorer/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/explorer/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalExplorerUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"explorer"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/facebook_ad_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFacebookAdCreativeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"facebook_ad_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/facebook_ad_creatives/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFacebookAdCreativePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"facebook_ad_creatives"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/facebook_ad_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFacebookAdGroupUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"facebook_ad_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/facebook_ad_groups/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalFacebookAdGroupPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"facebook_ad_groups"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/google_ads_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/google_ads_accounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/google_ads_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/google_ads_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/google_ads_integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsIntegrationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/google_ads_integrations/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsIntegrationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_integrations"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/google_ads_integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsIntegrationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/google_ads_integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGoogleAdsIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guideline_details/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:guideline_id/subscriptions(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelineSubscriptionsUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:guideline_id/subscriptions(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelineSubscriptionsPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelinesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalGuidelinesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/pipeline_trackers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPipelineTrackersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/pipeline_trackers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalPipelineTrackersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewChallengeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewChallengePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuideUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuidePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions/:id(.:format)
 * @param {any} reviewGuideId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuideSubscriptionUrl = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions/:id(.:format)
 * @param {any} reviewGuideId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuideSubscriptionPath = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions(.:format)
 * @param {any} reviewGuideId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuideSubscriptionsUrl = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions(.:format)
 * @param {any} reviewGuideId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuideSubscriptionsPath = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuidesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewGuidesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewProcessControlCheckUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/process_control_checks/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewProcessControlCheckPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/process_control_checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewProcessControlChecksUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/process_control_checks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalReviewProcessControlChecksPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"process_control_checks"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/scores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScoreUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/scores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScorePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/scores/:score_id/subscriptions(.:format)
 * @param {any} scoreId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScoreSubscriptionsUrl = /*#__PURE__*/ __jsr.r({"score_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"score_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/scores/:score_id/subscriptions(.:format)
 * @param {any} scoreId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScoreSubscriptionsPath = /*#__PURE__*/ __jsr.r({"score_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"score_id"],[2,[7,"/"],[2,[6,"subscriptions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScoresUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalScoresPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/:user_id/act_as(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUserActAsUrl = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"act_as"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/:user_id/act_as(.:format)
 * @param {any} userId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUserActAsPath = /*#__PURE__*/ __jsr.r({"user_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"user_id"],[2,[7,"/"],[2,[6,"act_as"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/versions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVersionUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/versions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVersionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"versions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVersionsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/versions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internalVersionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"versions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/iso_defaults(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const isoDefaultsApiCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"iso_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/iso_defaults(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const isoDefaultsApiCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"iso_defaults"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landingIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /landing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landingIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/assets/load_more(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loadMorePostGroupsAssetsUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"load_more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/assets/load_more(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loadMorePostGroupsAssetsPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"load_more"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const loginPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoutUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logoutPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/map_brand_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapBrandCodeTaxonomyUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_brand_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/map_brand_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapBrandCodeTaxonomyUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_brand_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns/:id/map_dimensions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapDimensionsTaxonomyCustomUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns/:id/map_dimensions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapDimensionsTaxonomyCustomUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/map_market_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapMarketCodeTaxonomyUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_market_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id/map_market_code(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mapMarketCodeTaxonomyUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"map_market_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup/market_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketChartSettingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"market_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup/market_chart(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketChartSettingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"market_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup/market_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketTableSettingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"market_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup/market_table(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const marketTableSettingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"market_table"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/match(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matchCreativeLifecycleCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"match"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/match(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const matchCreativeLifecycleCoreAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"match"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadataUserSsoSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/saml/metadata(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const metadataUserSsoSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"metadata"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupAdwordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adwords/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupAdwordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/display_ads_access/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupDisplayAdsAccessUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/display_ads_access/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupDisplayAdsAccessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"display_ads_access"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupFacebookAdUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupFacebookAdPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupFacebookPostUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupFacebookPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupInstagramPostUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupInstagramPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/my_target_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupMyTargetAdUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"my_target_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/my_target_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupMyTargetAdPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"my_target_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupSnapchatAdUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupSnapchatAdPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/twitter_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupTwitterAdUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/twitter_ads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupTwitterAdPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/twitter_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupTwitterPostUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/twitter_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupTwitterPostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/youtube_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupYoutubePostUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"youtube_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/youtube_posts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAccountSetupYoutubePostPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"youtube_posts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/analysis/words/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAnalysisWordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/analysis/words/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAnalysisWordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"analysis"],[2,[7,"/"],[2,[6,"words"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAuditReprocessUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminAuditReprocessPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCategoryUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/categories/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCategoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCategoryClassificationUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCategoryClassificationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminChannelUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/channels/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminChannelPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"channels"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyApiAuthorizationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/api_authorizations/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyApiAuthorizationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"api_authorizations"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyBrandUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyBrandPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyCategorySubscriptionUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/category_subscriptions/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyCategorySubscriptionPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"category_subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyChannelConfigUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/channel_configs/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyChannelConfigPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"channel_configs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/clients/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyClientUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/clients/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyClientPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"clients"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyContractUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/contracts/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyContractPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"contracts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/guidelines/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyGuidelineUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/guidelines/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyGuidelinePath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyOrganizationFeatureUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/organization_features/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanyOrganizationFeaturePath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"organization_features"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanySsoConfigurationUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/sso_configuration/new(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminCompanySsoConfigurationPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"sso_configuration"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/dv3b/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDv3bUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dv3b"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/dv3b/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminDv3bPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"dv3b"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEmailUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/email_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEmailSettingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/email_settings/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminEmailSettingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"email_settings"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminFeatureUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminFeaturePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminFeatureTrainingAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/features/:id/feature_training_assets/new(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminFeatureTrainingAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"features"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"feature_training_assets"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:guideline_id/guideline_details/new(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminGuidelineGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:guideline_id/guideline_details/new(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminGuidelineGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminJobUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/jobs/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminJobPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"jobs"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminLogoElementUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminLogoElementPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminOrganizationsDemoAccountUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminOrganizationsDemoAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminPartnerUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminPartnerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tracked_terms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTrackedTermUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tracked_terms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminTrackedTermPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tracked_terms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/ugc_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUgcFilterUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/ugc_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAdminUgcFilterPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"ugc_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/category_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCategoryFormUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_forms/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCategoryFormPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_forms"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_brand_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_brand_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/company_market_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/company_market_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newApiCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/challenges/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAuditChallengeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/challenges/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newAuditChallengePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /brand_cues/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBrandCueUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /brand_cues/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newBrandCuePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"brand_cues"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCreativeLifecycleCoreAssetUploadUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_asset_uploads/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newCreativeLifecycleCoreAssetUploadPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_asset_uploads"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalDV360AdAccountUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_ad_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalDV360AdAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_ad_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/dv360_campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalDV360CampaignUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/dv360_campaigns/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalDV360CampaignPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"dv360_campaigns"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/google_ads_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGoogleAdsAccountUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/google_ads_accounts/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGoogleAdsAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"google_ads_accounts"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGuidelineUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGuidelinePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:guideline_id/subscriptions/new(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGuidelineSubscriptionUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:guideline_id/subscriptions/new(.:format)
 * @param {any} guidelineId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalGuidelineSubscriptionPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalReviewGuideUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalReviewGuidePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions/new(.:format)
 * @param {any} reviewGuideId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalReviewGuideSubscriptionUrl = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/:review_guide_id/subscriptions/new(.:format)
 * @param {any} reviewGuideId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalReviewGuideSubscriptionPath = /*#__PURE__*/ __jsr.r({"review_guide_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[3,"review_guide_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/scores/:score_id/subscriptions/new(.:format)
 * @param {any} scoreId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalScoreSubscriptionUrl = /*#__PURE__*/ __jsr.r({"score_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"score_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/scores/:score_id/subscriptions/new(.:format)
 * @param {any} scoreId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newInternalScoreSubscriptionPath = /*#__PURE__*/ __jsr.r({"score_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"score_id"],[2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners/new_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLinkSettingsPartnersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners/new_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newLinkSettingsPartnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPreflightPretestUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newPreflightPretestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourceUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newRailsConductorInboundEmailSourcePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newReportingReportUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newReportingReportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSearchUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /search/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSearchPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/bulk_invite/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsBulkInviteUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/bulk_invite/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsBulkInvitePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/csv_exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCsvExportUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"csv_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/csv_exports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCsvExportPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"csv_exports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCustomFilterUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCustomFilterPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options/new(.:format)
 * @param {any} customFilterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCustomFilterOptionUrl = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options/new(.:format)
 * @param {any} customFilterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsCustomFilterOptionPath = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsLinkedPlatformAccountUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsLinkedPlatformAccountPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsPartnerUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsPartnerPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsUserUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newSettingsUserPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyTaxonomyUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCompanyTaxonomyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/bulk_upload/new(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCustomSegmentBulkUploadUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"bulk_upload"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/bulk_upload/new(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCustomSegmentBulkUploadPath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"bulk_upload"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCustomTaxonomyUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newTaxonomyCustomTaxonomyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/historical_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newThirdPartyHistoricalRequestUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/historical_requests/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newThirdPartyHistoricalRequestPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/new(.:format)
 * @param {any} integrationConfigId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newThirdPartyIntegrationConfigEligibilityRuleUrl = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/new(.:format)
 * @param {any} integrationConfigId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newThirdPartyIntegrationConfigEligibilityRulePath = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/saml/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSsoSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/saml/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserSsoSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserUnlockUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const newUserUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads/next_account_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nextAccountPageAccountSetupMetaAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"next_account_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads/next_account_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const nextAccountPageAccountSetupMetaAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"next_account_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/pretests/:id/notify_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifyUserAdminPretestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notify_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/pretests/:id/notify_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notifyUserAdminPretestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"notify_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthCallbackUrl = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /auth/:provider/callback(.:format)
 * @param {any} provider
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauthCallbackPath = /*#__PURE__*/ __jsr.r({"provider":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[3,"provider"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id/onboarding(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingSettingsUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id/onboarding(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboardingSettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewAdminRepresentationIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overviewAdminRepresentationIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/categories(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownedCategoriesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/categories(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownedCategoriesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/categories/:id(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownedCategoryUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/categories/:id(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ownedCategoryPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /stats/page_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pageActivityStatsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"page_activity"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stats/page_activity(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pageActivityStatsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"page_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stats/pages_without_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pagesWithoutTrackingStatsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"pages_without_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stats/pages_without_tracking(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pagesWithoutTrackingStatsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stats"],[2,[7,"/"],[2,[6,"pages_without_tracking"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audiences/overview(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidAudiencesOverviewIndexUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audiences/overview(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidAudiencesOverviewIndexPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audiences"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/audiences(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidAudiencesRootUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/audiences(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidAudiencesRootPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"audiences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/analytics(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesAnalyticsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/analytics(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesAnalyticsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/audience(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesAudienceIndexUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/audience(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesAudienceIndexPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories_graph(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesGraphUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories_graph(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesGraphPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories_graph"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/overview(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesOverviewIndexUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id/overview(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesOverviewIndexPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesRootUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/categories/:id(.:format)
 * @param {any} channel
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoriesRootPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/category_activity(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoryActivityUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"category_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/category_activity(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidCategoryActivityPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"category_activity"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidComparisonUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/compare/:view_type/:report_type(.:format)
 * @param {any} channel
 * @param {any} viewType
 * @param {any} reportType
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidComparisonPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"view_type":{"r":true},"report_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"compare"],[2,[7,"/"],[2,[3,"view_type"],[2,[7,"/"],[2,[3,"report_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidDashboardUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidDashboardPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/paid/summary_chart(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidSummaryChartUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"summary_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/paid/summary_chart(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paidSummaryChartPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"paid"],[2,[7,"/"],[2,[6,"summary_chart"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/:id/pdf_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfDataPreflightPretestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/:id/pdf_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pdfDataPreflightPretestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"pdf_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/assets(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsAssetsUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/assets(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsAssetsPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"assets"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/category_gap_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsCategoryGapAnalysisIndexUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"category_gap_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/category_gap_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsCategoryGapAnalysisIndexPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"category_gap_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsComparisonsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /comparisons(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsComparisonsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /comparisons/form/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsFormUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/form/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsFormPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[6,"form"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsFormOptionsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/form_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsFormOptionsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[6,"form_options"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/hashtag_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsHashtagAnalysisIndexUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"hashtag_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/hashtag_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsHashtagAnalysisIndexPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"hashtag_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/post_type_gap_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsPostTypeGapAnalysisIndexUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"post_type_gap_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/post_type_gap_analysis(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsPostTypeGapAnalysisIndexPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"post_type_gap_analysis"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/timeseries(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsTimeseriesIndexUrl = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"timeseries"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /comparisons/:comparison_id/timeseries(.:format)
 * @param {any} comparisonId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postGroupsTimeseriesIndexPath = /*#__PURE__*/ __jsr.r({"comparison_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"comparisons"],[2,[7,"/"],[2,[3,"comparison_id"],[2,[7,"/"],[2,[6,"timeseries"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/post_info(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postInfoAdminReviewGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"post_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/post_info(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const postInfoAdminReviewGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"post_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id/preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preferencesSettingsUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id/preferences(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preferencesSettingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preferences"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /preflight(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /preflight/pdf_scorecards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPdfScorecardUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pdf_scorecards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pdf_scorecards/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPdfScorecardPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pdf_scorecards"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPretestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPretestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPretestsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightPretestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /preflight/rankings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightRankingsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/rankings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightRankingsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"rankings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /preflight/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/preflights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightsPreflightPretestsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"preflights"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/preflights(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preflightsPreflightPretestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"preflights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /upload/assets/presigned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presignedUploadAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"presigned"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /upload/assets/presigned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const presignedUploadAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"upload"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[6,"presigned"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id/process_query(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processQueryAdminAuditReprocessUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id/process_query(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processQueryAdminAuditReprocessPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_query"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adform_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupAdformAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adform_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupAdformAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adform_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupAmazonAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/amazon_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupAmazonAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"amazon_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id/process_step(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupFacebookAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/:id/process_step(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupFacebookAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupFacebookBrandPageUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupFacebookBrandPagePath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupMetaAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupMetaAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupTiktokAdUrl = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:step/process_step(.:format)
 * @param {any} step
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const processStepAccountSetupTiktokAdPath = /*#__PURE__*/ __jsr.r({"step":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"step"],[2,[7,"/"],[2,[6,"process_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/props(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const propsAdminReviewGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/guidelines/:guideline_id/checks/:id/props(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const propsAdminReviewGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"props"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationUrl = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyUrl = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signedBlobId
 * @param {any} variationKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsBlobRepresentationProxyPath = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncinerateUrl = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailIncineratePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailRerouteUrl = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inboundEmailId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailReroutePath = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailSourcesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsConductorInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDirectUploadsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServiceUrl = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encodedKey
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPropertiesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/info/properties(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoPropertiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"properties"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoRoutesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/info/routes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsInfoRoutesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"info"],[2,[7,"/"],[2,[6,"routes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /rails/mailers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"mailers"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMailgunInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsMandrillInboundHealthCheckPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsPostmarkInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsRelayInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsSendgridInboundEmailsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobUrl = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyUrl = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signedId
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const railsServiceBlobProxyPath = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/reconnect_inactive_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectInactivePageAccountSetupFacebookBrandPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"reconnect_inactive_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/reconnect_inactive_page(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectInactivePageAccountSetupFacebookBrandPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"reconnect_inactive_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads/reconnect_lapsed_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectLapsedAccountsAccountSetupMetaAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"reconnect_lapsed_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads/reconnect_lapsed_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectLapsedAccountsAccountSetupMetaAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"reconnect_lapsed_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/reconnect_lapsed_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectLapsedPagesAccountSetupFacebookBrandPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"reconnect_lapsed_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/reconnect_lapsed_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reconnectLapsedPagesAccountSetupFacebookBrandPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"reconnect_lapsed_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/refresh_cache(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshCacheAdminAuditOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[6,"refresh_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/refresh_cache(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refreshCacheAdminAuditOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[6,"refresh_cache"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /regulatory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regulatoryUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regulatory"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /regulatory(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regulatoryPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regulatory"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /regulatory/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regulatoryOverviewIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regulatory"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /regulatory/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regulatoryOverviewIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"regulatory"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupDV360AdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupDV360AdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupInstagramPostUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupInstagramPostPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/pinterest/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupPinterestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/pinterest/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupPinterestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupSnapchatAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupSnapchatAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupTiktokUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:id/relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkAccountSetupTiktokPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/pinterest/:id/relink_callback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkCallbackAccountSetupPinterestUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/pinterest/:id/relink_callback(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkCallbackAccountSetupPinterestPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"pinterest"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupDV360AdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupDV360AdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupInstagramPostUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupInstagramPostPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupSnapchatAdUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/snapchat_ads/:id/relink_instructions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkInstructionsAccountSetupSnapchatAdPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"snapchat_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:id/relink_intent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkIntentAccountSetupTiktokUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/:id/relink_intent(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const relinkIntentAccountSetupTiktokPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"relink_intent"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom/manually_mapped_campaigns/:id/remap_dimensions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remapDimensionsTaxonomyCustomManuallyMappedCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remap_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom/manually_mapped_campaigns/:id/remap_dimensions(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remapDimensionsTaxonomyCustomManuallyMappedCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remap_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/rematch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rematchCreativeLifecycleCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"rematch"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/rematch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rematchCreativeLifecycleCoreAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"rematch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api/category_assets/remove_category_asset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeCategoryAssetApiCategoryAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[2,[7,"/"],[2,[6,"remove_category_asset"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/category_assets/remove_category_asset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const removeCategoryAssetApiCategoryAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"category_assets"],[2,[7,"/"],[2,[6,"remove_category_asset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingApiUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingApiPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /reporting/reports/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingReportUrl = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/:uuid(.:format)
 * @param {any} uuid
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingReportPath = /*#__PURE__*/ __jsr.r({"uuid":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[3,"uuid"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /representation/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const representationReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /representation/overview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const representationReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[6,"overview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /third_party/historical_requests/request_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestCountThirdPartyHistoricalRequestsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[2,[7,"/"],[2,[6,"request_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/historical_requests/request_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestCountThirdPartyHistoricalRequestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[2,[7,"/"],[2,[6,"request_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adwords/:id/request_reactivation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestReactivationAccountSetupAdwordUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_reactivation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adwords/:id/request_reactivation(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestReactivationAccountSetupAdwordPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_reactivation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/adwords/:id/request_relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestRelinkAccountSetupAdwordUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/adwords/:id/request_relink(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const requestRelinkAccountSetupAdwordPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"adwords"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"request_relink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /accounts/reset_facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFacebookAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"reset_facebook"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /accounts/reset_facebook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resetFacebookAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"reset_facebook"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/inflight/guidelines/:guideline_id/checks/:id/review(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewAdminReviewInflightGuidelineCheckUrl = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/inflight/guidelines/:guideline_id/checks/:id/review(.:format)
 * @param {any} guidelineId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviewAdminReviewInflightGuidelineCheckPath = /*#__PURE__*/ __jsr.r({"guideline_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"inflight"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"guideline_id"],[2,[7,"/"],[2,[6,"checks"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/users/:id/roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rolesInternalUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/users/:id/roles(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rolesInternalUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"roles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/error_queries/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runInternalErrorQueryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/error_queries/:id/run(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const runInternalErrorQueryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"error_queries"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"run"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/safe_zone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safeZoneInternalReviewChallengeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"safe_zone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/:id/safe_zone(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const safeZoneInternalReviewChallengePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"safe_zone"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scores/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scorePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scores/:id/score_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreDataScoreUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"score_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scores/:id/score_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreDataScorePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"score_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/score_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreGroupingDimensionsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"score_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/score_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreGroupingDimensionsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"score_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/score_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreRecordsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"score_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/score_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoreRecordsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"score_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoresUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scores(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoresPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/scoring/consistency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoringConsistencyUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scoring"],[2,[7,"/"],[2,[6,"consistency"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scoring/consistency(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scoringConsistencyPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scoring"],[2,[7,"/"],[2,[6,"consistency"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /search/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/search_hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchHashtagsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"search_hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/search_hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchHashtagsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"search_hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts/search_instagram_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchInstagramAccountsAdminOrganizationsDemoAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[2,[7,"/"],[2,[6,"search_instagram_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/organizations/demo_accounts/search_instagram_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const searchInstagramAccountsAdminOrganizationsDemoAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"demo_accounts"],[2,[7,"/"],[2,[6,"search_instagram_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/select_business_centers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectBusinessCentersAccountSetupTiktokAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[6,"select_business_centers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/tiktok_ads/select_business_centers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectBusinessCentersAccountSetupTiktokAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"tiktok_ads"],[2,[7,"/"],[2,[6,"select_business_centers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/meta_ads/select_business_managers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectBusinessManagersAccountSetupMetaAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"select_business_managers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/meta_ads/select_business_managers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectBusinessManagersAccountSetupMetaAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"meta_ads"],[2,[7,"/"],[2,[6,"select_business_managers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/twitter_ads/select_handles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectHandlesAccountSetupTwitterAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[2,[7,"/"],[2,[6,"select_handles"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/twitter_ads/select_handles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectHandlesAccountSetupTwitterAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"twitter_ads"],[2,[7,"/"],[2,[6,"select_handles"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/select_partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectPartnerAccountSetupDV360AdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"select_partner"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/select_partner(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectPartnerAccountSetupDV360AdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"select_partner"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/select_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectTypeReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"select_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/select_type(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selectTypeReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"select_type"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/bulk_invite/csv_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsBulkInviteCsvTemplateUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[2,[7,"/"],[2,[6,"csv_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/bulk_invite/csv_template(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsBulkInviteCsvTemplatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[2,[7,"/"],[2,[6,"csv_template"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/bulk_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsBulkInviteIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/bulk_invite(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsBulkInviteIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"bulk_invite"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCompanyLogoUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/logo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCompanyLogoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/csv_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCsvExportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"csv_exports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/csv_exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCsvExportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"csv_exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options/:id(.:format)
 * @param {any} customFilterId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterOptionUrl = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options/:id(.:format)
 * @param {any} customFilterId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterOptionPath = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options(.:format)
 * @param {any} customFilterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterOptionsUrl = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters/:custom_filter_id/custom_filter_options(.:format)
 * @param {any} customFilterId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFilterOptionsPath = /*#__PURE__*/ __jsr.r({"custom_filter_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[2,[7,"/"],[2,[3,"custom_filter_id"],[2,[7,"/"],[2,[6,"custom_filter_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/custom_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFiltersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/custom_filters(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsCustomFiltersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"custom_filters"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/facebook_ad_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsFacebookAdPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/facebook_ad_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsFacebookAdPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"facebook_ad_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLinkedPlatformAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLinkedPlatformAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLinkedPlatformAccountsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsLinkedPlatformAccountsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPartnerUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPartnerPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPartnersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/partners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsPartnersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"partners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUserUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUserPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/permissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUserPermissionUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/permissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUserPermissionPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"permissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUsersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settingsUsersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/setup_first_linking_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupFirstLinkingStepAccountSetupFacebookAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"setup_first_linking_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/setup_first_linking_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupFirstLinkingStepAccountSetupFacebookAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"setup_first_linking_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/setup_first_linking_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupFirstLinkingStepAccountSetupFacebookBrandPagesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"setup_first_linking_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_brand_pages/setup_first_linking_step(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupFirstLinkingStepAccountSetupFacebookBrandPagesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_brand_pages"],[2,[7,"/"],[2,[6,"setup_first_linking_step"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupInstructionsAccountSetupDV360AdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/dv360_ads/setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupInstructionsAccountSetupDV360AdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"dv360_ads"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupInstructionsAccountSetupInstagramPostsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/instagram_posts/setup_instructions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const setupInstructionsAccountSetupInstagramPostsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"instagram_posts"],[2,[7,"/"],[2,[6,"setup_instructions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/show/:report_id(.:format)
 * @param {any} channel
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showComparisonCustomUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare/show/:report_id(.:format)
 * @param {any} channel
 * @param {any} reportId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showComparisonCustomPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"report_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[2,[7,"/"],[2,[6,"show"],[2,[7,"/"],[2,[3,"report_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /api/assets/:id/show_content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showContentApiAssetUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /api/assets/:id/show_content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const showContentApiAssetPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"api"],[2,[7,"/"],[2,[6,"assets"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"show_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebUrl = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]], true);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sidekiqWebPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signupUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signupPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statusIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:channel/:media_type/categories/:id/subcategories(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcategoriesUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subcategories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/:media_type/categories/:id/subcategories(.:format)
 * @param {any} channel
 * @param {any} mediaType
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcategoriesPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"media_type":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[3,"media_type"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subcategories"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/category_classifications/:id/subcategory_edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcategoryEditAdminCategoryClassificationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subcategory_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/category_classifications/:id/subcategory_edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subcategoryEditAdminCategoryClassificationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"category_classifications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subcategory_edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review/challenges/summary_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summaryCsvInternalReviewChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"summary_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review/challenges/summary_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const summaryCsvInternalReviewChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"summary_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /search/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagsSearchIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /search/tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tagsSearchIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"search"],[2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyBrandCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyBrandCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyBrandCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_brand_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyBrandCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_brand_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyMarketCodeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyMarketCodePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyMarketCodesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_market_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyMarketCodesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_market_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyTaxonomiesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyTaxonomiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCompanyTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCreativeTaxonomiesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCreativeTaxonomiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCreativeTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCreativeTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom/manually_mapped_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomManuallyMappedCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom/manually_mapped_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomManuallyMappedCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/bulk_upload(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentBulkUploadIndexUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"bulk_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/bulk_upload(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentBulkUploadIndexPath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"bulk_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/codes/:id(.:format)
 * @param {any} customSegmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentCodeUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/codes/:id(.:format)
 * @param {any} customSegmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentCodePath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"codes"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/codes(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentCodesUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/codes(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentCodesPath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/values/:id(.:format)
 * @param {any} customSegmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentValueUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/values/:id(.:format)
 * @param {any} customSegmentId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentValuePath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"values"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/values(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentValuesUrl = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments/:custom_segment_id/values(.:format)
 * @param {any} customSegmentId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentValuesPath = /*#__PURE__*/ __jsr.r({"custom_segment_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[2,[7,"/"],[2,[3,"custom_segment_id"],[2,[7,"/"],[2,[6,"values"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_segments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_segments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomSegmentsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_segments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomTaxonomiesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomTaxonomiesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom_taxonomies/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom_taxonomies"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomUnparsableCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/custom/unparsable_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyCustomUnparsableCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"custom"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/manually_mapped_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyManuallyMappedCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/manually_mapped_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyManuallyMappedCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/manually_mapped_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyManuallyMappedCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/manually_mapped_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyManuallyMappedCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"manually_mapped_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyRootUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /taxonomy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyRootPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyUnparsableCampaignUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyUnparsableCampaignPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyUnparsableCampaignsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/unparsable_campaigns(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxonomyUnparsableCampaignsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"unparsable_campaigns"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teaspoon
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonUrl = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"teaspoon"]], true);

/**
 * Generates rails route to
 * /teaspoon
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonPath = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"teaspoon"]]);

/**
 * Generates rails route to
 * /teaspoon/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonRootUrl = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]], true);

/**
 * Generates rails route to
 * /teaspoon/
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonRootPath = /*#__PURE__*/ __jsr.r({}, [2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]]);

/**
 * Generates rails route to
 * /teaspoon/fixtures/*filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonFixtureUrl = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]],[2,[6,"fixtures"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /teaspoon/fixtures/*filename(.:format)
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonFixturePath = /*#__PURE__*/ __jsr.r({"filename":{"r":true},"format":{}}, [2,[2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]],[2,[6,"fixtures"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /teaspoon/:suite(.:format)
 * @param {any} suite
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonSuiteUrl = /*#__PURE__*/ __jsr.r({"suite":{"r":true,"d":"default"},"format":{}}, [2,[2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]],[2,[3,"suite"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /teaspoon/:suite(.:format)
 * @param {any} suite
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const teaspoonSuitePath = /*#__PURE__*/ __jsr.r({"suite":{"r":true,"d":"default"},"format":{}}, [2,[2,[2,[7,"/"],[6,"teaspoon"]],[7,"/"]],[2,[3,"suite"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /third_party/historical_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyHistoricalRequestsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/historical_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyHistoricalRequestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"historical_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/:id(.:format)
 * @param {any} integrationConfigId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigEligibilityRuleUrl = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules/:id(.:format)
 * @param {any} integrationConfigId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigEligibilityRulePath = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules(.:format)
 * @param {any} integrationConfigId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigEligibilityRulesUrl = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests/:integration_config_id/eligibility_rules(.:format)
 * @param {any} integrationConfigId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigEligibilityRulesPath = /*#__PURE__*/ __jsr.r({"integration_config_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[2,[7,"/"],[2,[3,"integration_config_id"],[2,[7,"/"],[2,[6,"eligibility_rules"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /third_party/score_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/score_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationConfigsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"score_requests"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /third_party/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /third_party/integrations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const thirdPartyIntegrationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"third_party"],[2,[7,"/"],[2,[6,"integrations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/tiers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tierUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/tiers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tierPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/tiers/:id/tier_collection_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tierCollectionDataTierUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tier_collection_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/tiers/:id/tier_collection_data(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tierCollectionDataTierPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"tiers"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"tier_collection_data"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/time_period_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timePeriodGroupingDimensionsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_period_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/time_period_grouping_dimensions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timePeriodGroupingDimensionsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_period_grouping_dimensions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /reporting/reports/time_period_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timePeriodRecordsReportingReportsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_period_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /reporting/reports/time_period_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timePeriodRecordsReportingReportsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reporting"],[2,[7,"/"],[2,[6,"reports"],[2,[7,"/"],[2,[6,"time_period_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/time_series_hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeSeriesHashtagsUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"time_series_hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/time_series_hashtags(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const timeSeriesHashtagsPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"time_series_hashtags"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleActiveTaxonomyCreativeTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/creative_taxonomies/:id/toggle_active(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleActiveTaxonomyCreativeTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"creative_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_active"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guideline_details/:id/toggle_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStateInternalGuidelineDetailUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guideline_details/:id/toggle_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStateInternalGuidelineDetailPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guideline_details"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id/toggle_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStateTaxonomyCompanyTaxonomyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /taxonomy/company_taxonomies/:id/toggle_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const toggleStateTaxonomyCompanyTaxonomyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"taxonomy"],[2,[7,"/"],[2,[6,"company_taxonomies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"toggle_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pipeline_trackers/tracker_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackerAdsInternalPipelineTrackersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[2,[7,"/"],[2,[6,"tracker_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/pipeline_trackers/tracker_ads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackerAdsInternalPipelineTrackersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[2,[7,"/"],[2,[6,"tracker_ads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/pipeline_trackers/tracker_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackerIdsInternalPipelineTrackersUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[2,[7,"/"],[2,[6,"tracker_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/pipeline_trackers/tracker_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const trackerIdsInternalPipelineTrackersPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"pipeline_trackers"],[2,[7,"/"],[2,[6,"tracker_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /twitter/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterCategoryImagesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /twitter/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterCategoryImagesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twitter/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterCategoryImagesOutsideDateRangeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /twitter/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterCategoryImagesOutsideDateRangePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /twitter/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /twitter/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twitterIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /two_factor_authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticateUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authenticate"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /two_factor_authenticate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const twoFactorAuthenticatePath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two_factor_authenticate"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unauthenticatedRootUrl = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unauthenticatedRootPath = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/unmatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmatchCreativeLifecycleCoreAssetsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"unmatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/core_assets/unmatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unmatchCreativeLifecycleCoreAssetsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"core_assets"],[2,[7,"/"],[2,[6,"unmatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/update_brand_words(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateBrandWordsAdminCompanyBrandUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_brand_words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/brands/:id/update_brand_words(.:format)
 * @param {any} companyId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateBrandWordsAdminCompanyBrandPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"brands"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_brand_words"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateComparisonCustomUrl = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:channel/owned/custom_compare(.:format)
 * @param {any} channel
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateComparisonCustomPath = /*#__PURE__*/ __jsr.r({"channel":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"channel"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"custom_compare"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:id/update_data_permission(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDataPermissionAdminCompanyUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_data_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:id/update_data_permission(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDataPermissionAdminCompanyPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_data_permission"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scores/:id/update_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDefaultScoreUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scores/:id/update_default(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateDefaultScorePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_default"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/guidelines/:id/update_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateImageAdminGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/guidelines/:id/update_image(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateImageAdminGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_image"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/review/organizations/update_pins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePinsAdminReviewOrganizationsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"update_pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/review/organizations/update_pins(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updatePinsAdminReviewOrganizationsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"review"],[2,[7,"/"],[2,[6,"organizations"],[2,[7,"/"],[2,[6,"update_pins"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServiceUrl = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encodedToken
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateRailsDiskServicePath = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id/update_reviewability(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateReviewabilityAdminAuditPostUrl = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_reviewability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_organizations/:org_id/audit_posts/:id/update_reviewability(.:format)
 * @param {any} orgId
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateReviewabilityAdminAuditPostPath = /*#__PURE__*/ __jsr.r({"org_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_organizations"],[2,[7,"/"],[2,[3,"org_id"],[2,[7,"/"],[2,[6,"audit_posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_reviewability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/representation/:id/update_reviewability(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateReviewabilityAdminRepresentationUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_reviewability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/representation/:id/update_reviewability(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateReviewabilityAdminRepresentationPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"representation"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_reviewability"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/companies/:company_id/scores/update_scores(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateScoresAdminCompanyScoresUrl = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[6,"update_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/companies/:company_id/scores/update_scores(.:format)
 * @param {any} companyId
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateScoresAdminCompanyScoresPath = /*#__PURE__*/ __jsr.r({"company_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"companies"],[2,[7,"/"],[2,[3,"company_id"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[6,"update_scores"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/guidelines/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStateInternalGuidelineUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/guidelines/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStateInternalGuidelinePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"guidelines"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStateSettingsLinkedPlatformAccountUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/accounts/linked/:id/update_state(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateStateSettingsLinkedPlatformAccountPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"accounts"],[2,[7,"/"],[2,[6,"linked"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/categories/:id/update_visibility(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVisibilityAdminCategoryUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/categories/:id/update_visibility(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateVisibilityAdminCategoryPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_visibility"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audit/scores/:id/update_weights(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateWeightsScoreUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_weights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/scores/:id/update_weights(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updateWeightsScorePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"scores"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"update_weights"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/logo_elements/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAdminLogoElementsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/logo_elements/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAdminLogoElementsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"logo_elements"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/tags/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAdminTagsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/tags/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAdminTagsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"tags"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/review_guides/upload_asset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAssetInternalReviewGuidesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[6,"upload_asset"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/review_guides/upload_asset(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadAssetInternalReviewGuidesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"review_guides"],[2,[7,"/"],[2,[6,"upload_asset"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/logo/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadSettingsCompanyLogoUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/logo/upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const uploadSettingsCompanyLogoPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"logo"],[2,[7,"/"],[2,[6,"upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /preflight/pretests/url_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const urlUploadPreflightPretestsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"url_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preflight/pretests/url_upload(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const urlUploadPreflightPretestsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"preflight"],[2,[7,"/"],[2,[6,"pretests"],[2,[7,"/"],[2,[6,"url_upload"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard/usage_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usageRecordsCreativeLifecycleDashboardIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"usage_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /creative_lifecycle/dashboard/usage_records(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const usageRecordsCreativeLifecycleDashboardIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"creative_lifecycle"],[2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"usage_records"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/setup/user_breakdown(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBreakdownSettingsCompanyOnboardingUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"user_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/setup/user_breakdown(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userBreakdownSettingsCompanyOnboardingPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"setup"],[2,[7,"/"],[2,[6,"user_breakdown"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/password_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordExpiredUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_expired"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/password_expired(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userPasswordExpiredPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"password_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userRegistrationPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/saml/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSsoSessionUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/saml/auth(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userSsoSessionPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"saml"],[2,[7,"/"],[2,[6,"auth"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUnlockUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/unlock(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const userUnlockPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unlock"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audit/challenges/valid_cx_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validCxIdsAuditChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"valid_cx_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /audit/challenges/valid_cx_ids(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const validCxIdsAuditChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audit"],[2,[7,"/"],[2,[6,"challenges"],[2,[7,"/"],[2,[6,"valid_cx_ids"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyAdminAuditReprocessUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_reprocesses/:id/verify(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyAdminAuditReprocessPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_reprocesses"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/verify_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyPagesAccountSetupFacebookAdsUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"verify_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /account_setup/facebook_ads/verify_pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verifyPagesAccountSetupFacebookAdsPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"account_setup"],[2,[7,"/"],[2,[6,"facebook_ads"],[2,[7,"/"],[2,[6,"verify_pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /admin/audit_challenges/weekly_summary_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weeklySummaryCsvAdminAuditChallengesUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_challenges"],[2,[7,"/"],[2,[6,"weekly_summary_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /admin/audit_challenges/weekly_summary_csv(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const weeklySummaryCsvAdminAuditChallengesPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"audit_challenges"],[2,[7,"/"],[2,[6,"weekly_summary_csv"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /youtube/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeCategoryImagesUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /youtube/owned/categories/:id/images(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeCategoryImagesPath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /youtube/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeCategoryImagesOutsideDateRangeUrl = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /youtube/owned/categories/:id/images_outside_date_range(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeCategoryImagesOutsideDateRangePath = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[2,[7,"/"],[2,[6,"categories"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"images_outside_date_range"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /youtube/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeIndexUrl = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /youtube/owned(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const youtubeIndexPath = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"owned"],[1,[2,[8,"."],[3,"format"]]]]]]]);

